import React from 'react';
import { Box, Grid, Skeleton, useMediaQuery, useTheme } from '@mui/material';
import VideoSubjectSkeleton from './VideoSubjectSkeleton';

const AlbumSubjectSkeleton: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));
  const collapsedRows = isMobile ? 3 : 2;
  const itemsPerRow = isMobile ? 2 : (isXl ? 4 : 3);
  const count = collapsedRows * itemsPerRow;
  return (
    <Box sx={{ mt: 0.5, mb: 4 }}>
      <Box sx={{ px: { xs: 1, sm: 2 }, mb: 0.5 }}>
        <Skeleton variant="text" width="40%" />
      </Box>
      <Grid container sx={{ mx: { xs: -1, sm: 0 } }}>
        {Array.from({ length: count }).map((_, idx) => (
          <Grid
            key={idx}
            size={{ xs: 6, md: 4, xl: 3 }}
            sx={{ px: { xs: 1, sm: 2 }, py: 1 }}
          >
            <VideoSubjectSkeleton />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AlbumSubjectSkeleton;